import CustomersMap from './CustomersMap'
import SalesZonesMap from './SalesZonesMap'

interface LocationsMapsProps {
  customers: any[]
  sales: any[]
}

/**
 * Shared body for the "mapa de ubicaciones" view -- used by both the admin
 * page (all sellers, or one via a filter) and each seller's own page
 * (already scoped server-side to their own data). Stacked full-width rather
 * than side-by-side: at half-viewport width the sales heat-map read as a
 * cluttered blob, and there was no reason not to give each map the whole
 * row once color already carries the intensity signal.
 */
export default function LocationsMaps({ customers, sales }: LocationsMapsProps) {
  const locatedCustomers = customers.filter((c) => c.latitude != null && c.longitude != null)
  const locatedSales = sales.filter((s) => s.gps_latitude != null && s.gps_longitude != null)

  return (
    <div className="grid grid-cols-1 gap-6">
      <div className="bg-cream-50 shadow rounded-lg border border-cream-200 p-6">
        <h3 className="text-lg font-medium text-espresso-800 mb-1">Clientes</h3>
        <p className="text-xs text-espresso-500 mb-4">
          Ubicación de los clientes que tienen coordenadas registradas ({locatedCustomers.length} de{' '}
          {customers.length}).
        </p>
        {locatedCustomers.length === 0 ? (
          <p className="text-espresso-500">
            Todavía no hay clientes con ubicación registrada. Se agregan al crear o editar un cliente desde el
            mapa del formulario.
          </p>
        ) : (
          <CustomersMap customers={locatedCustomers} height={520} />
        )}
      </div>

      <div className="bg-cream-50 shadow rounded-lg border border-cream-200 p-6">
        <h3 className="text-lg font-medium text-espresso-800 mb-1">Ventas</h3>
        <p className="text-xs text-espresso-500 mb-4">
          Ubicación de las ventas que tienen coordenadas registradas ({locatedSales.length} de {sales.length}).
        </p>
        {locatedSales.length === 0 ? (
          <p className="text-espresso-500">
            Todavía no hay ventas con ubicación registrada. Se capturan automáticamente al registrar una venta
            desde el celular.
          </p>
        ) : (
          <SalesZonesMap sales={locatedSales} height={520} />
        )}
      </div>
    </div>
  )
}
